/* ECOALCA Search Fix - JS */
(function() {
  let scrollPos = 0;

  function init() {
    const details = document.querySelector('.header__search details');
    if (!details) return;

    new MutationObserver(function() {
      if (details.open) {
        scrollPos = window.scrollY;
        document.body.classList.add('search-open');
        document.body.style.top = -scrollPos + 'px';
      } else {
        document.body.classList.remove('search-open');
        document.body.style.top = '';
        window.scrollTo(0, scrollPos);
      }
    }).observe(details, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
